import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editorial-board',
  templateUrl: './editorial-board.component.html',
  styleUrls: ['./editorial-board.component.css']
})
export class EditorialBoardComponent{


}
